import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isPlanningPhase',
})
export class IsPlanningPhasePipe implements PipeTransform {

  transform(planEnd: any): boolean {
    const today = new Date();
    const planEndDate = new Date(planEnd);
    return planEndDate >= today;
  }

}
